'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BoardIcon = require('../../../../element/board/boardIcon/BoardIcon');

var _BoardIcon2 = _interopRequireDefault(_BoardIcon);

require('./BoardPopupListItem.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var BoardPopupListItemLoading = function BoardPopupListItemLoading(props) {
    return _react2.default.createElement('div', { className: 'BoardPopupListItemLoading' });
};

// Styles
// Lib


var BoardPopupListItem = function BoardPopupListItem(props) {
    var linkURL = props.linkURL,
        board = props.board,
        users = props.users,
        navigateToLinkedBoard = props.navigateToLinkedBoard,
        active = props.active,
        TimestampComponent = props.TimestampComponent,
        ActivityComponent = props.ActivityComponent,
        className = props.className,
        isNew = props.isNew;


    if (!board || !users.length && !users.size) return _react2.default.createElement(BoardPopupListItemLoading, null);

    var _linkURL = linkURL || '/' + board.get('id');

    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('BoardPopupListItem', className, { active: active }),
            href: _linkURL,
            onClick: navigateToLinkedBoard },
        _react2.default.createElement(
            'div',
            { className: 'icon' },
            _react2.default.createElement(_BoardIcon2.default, {
                icon: board.getIn(['content', 'icon']),
                element: board,
                color: board.getIn(['content', 'color']),
                size: 5 })
        ),
        _react2.default.createElement(
            'div',
            { className: 'message' },
            _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                    'span',
                    { className: 'board-name' },
                    board.getIn(['content', 'title'])
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'timestamp' },
                _react2.default.createElement(TimestampComponent, props)
            ),
            _react2.default.createElement(
                'div',
                { className: 'activity' },
                _react2.default.createElement(ActivityComponent, props)
            )
        ),
        isNew ? _react2.default.createElement('div', { className: 'new-marker' }) : null
    );
};

BoardPopupListItem.propTypes = {
    linkURL: _propTypes2.default.string,
    board: _propTypes2.default.object.isRequired,
    users: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]).isRequired,
    navigateToLinkedBoard: _propTypes2.default.func,
    active: _propTypes2.default.bool,
    isNew: _propTypes2.default.bool,
    TimestampComponent: _propTypes2.default.func,
    ActivityComponent: _propTypes2.default.func,
    className: _propTypes2.default.string
};

exports.default = BoardPopupListItem;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/types/listItems/BoardPopupListItem.js
// module id = 715
// module chunks = 0